/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiConfigMemory200,
  GetApiV1TutoraiConfigMemory401,
  GetApiV1TutoraiConfigMemory500,
  GetApiV1TutoraiConfigMemoryQueryParams,
  GetApiV1TutoraiConfigMemoryQueryResponse,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigMemory.ts";
import { tutorAIPromptConfigViewModelSchema } from "../tutorAIPromptConfigViewModelSchema.ts";

export const getApiV1TutoraiConfigMemoryQueryParamsSchema = z
  .object({
    classStudentId: z.optional(z.coerce.number().int()),
    personId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1TutoraiConfigMemoryQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiConfigMemory200Schema = z.lazy(
  () => tutorAIPromptConfigViewModelSchema,
) as unknown as ToZod<GetApiV1TutoraiConfigMemory200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiConfigMemory401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiConfigMemory401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiConfigMemory500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiConfigMemory500>;

export const getApiV1TutoraiConfigMemoryQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiConfigMemory200Schema,
) as unknown as ToZod<GetApiV1TutoraiConfigMemoryQueryResponse>;
